import { RootState } from "src/state/delegate";
import { serverOwnedConfigSelectors } from "src/state/selectors";

export const getBroadcastBanubaConfigUrl = (state: RootState) =>
  serverOwnedConfigSelectors.getConfigParamByKey(
    state,
    "broadcast.banuba.config.url",
    "https://storage.googleapis.com/resources.tango.me/banuba-resources/config/bnb_config-v41-ad74d12.json"
  );
